import { useCallback } from 'react'

import { TextField } from '@workwave-tidal/core/components'

import { useDebounce } from '@/hooks'

interface Props {
  label: string
  value: number
  onChange: (label: string, value: number) => void
  testId?: string
  disabled?: boolean
}

export function Field(props: Props) {
  const { testId, label, value, onChange, disabled } = props

  const handleOnChangeValue = useCallback(
    (value: number) => {
      onChange(label, value)
    },
    [onChange, label],
  )

  const [debounceValue, debounceOnChange] = useDebounce({
    value,
    onChange: handleOnChangeValue,
    delay: 300,
  })

  return (
    <TextField
      key={label}
      label={label}
      value={debounceValue}
      onChange={e => debounceOnChange(Number(e.target.value))}
      disabled={disabled}
      data-testid={testId}
      type="number"
    />
  )
}
